<template>
  <div class="community-item" v-if="communityData" @click="toArticleDetail">
    <template v-if="communityData.page">
      <div class="community-item-page flex-between" v-if="communityData.page.token" @click.stop="toBlogDetail">
        <div class="page-info flex-column">
          <span class="page-title">三面结束，许愿成功入职大厂</span>
          <span class="page-desc">听说WonderCV许愿池很灵，求个同花顺offer</span>
        </div>
        <img src="" alt="">
      </div>
    </template>
    <div class="community-item-content">
      <div class="community-item-title">
        <div class="messages">
          <img :src="communityData.from_user.avatar_url" alt=""
               v-if="!communityData.admin_id&&communityData.operation!='vote_end'&&communityData.operation!='participant_vote_end'">
          <img src="https://files.wondercv.com/icon/community.png" alt=""
               v-if="communityData.admin_id&&communityData.operation!='admin_like'&&communityData.operation!='admin_comment'||communityData.operation=='vote_end'||communityData.operation=='participant_vote_end'">
          <h1 v-if="!communityData.admin_id&&communityData.operation!='vote_end'&&communityData.operation!='participant_vote_end'">
            {{communityData.from_user.username || '超级简历用户'}}{{communityData.remark > 1 ? '等' + communityData.remark + '人' : ''}}&nbsp;&nbsp;&nbsp;{{operationType(communityData.operation)}}了你的{{noticeType(communityData.type)}}</h1>
          <h1 v-if="communityData.operation=='participant_vote_end'">你参与的投票已结束，来看看吧</h1>
          <h1 v-if="communityData.operation=='vote_end'">Hi～你发起的投票已结束，来看看投票结果吧</h1>
          <h1 v-if="communityData.admin_id && communityData.operation==='top'">
            你的{{noticeType(communityData.type)}}被社区管理员&nbsp;&nbsp;&nbsp;设置为置顶</h1>
          <h1 v-if="communityData.admin_id && communityData.operation==='delete'">
            你的{{noticeType(communityData.type)}}被社区管理员&nbsp;&nbsp;&nbsp;删除</h1>
          <!--          <h1 v-if="communityData.admin_id && communityData.operation==='hot'">你的{{noticeType(communityData.type)
          }}被社区管理员&nbsp;&nbsp;&nbsp;推荐为热门</h1>-->
          <h1 v-if="communityData.admin_id && communityData.operation==='update_topic'">
            你的{{noticeType(communityData.type)}}被社区管理员&nbsp;&nbsp;&nbsp;修改了话题</h1>
          <h1 v-if="communityData.admin_id && communityData.operation==='tag'">
            你的{{noticeType(communityData.type)}}被社区管理员&nbsp;&nbsp;&nbsp;推荐为热门</h1>
          <img :src="communityData.from_user.avatar_url" alt=""
               v-if="communityData.admin_id&&(communityData.operation=='admin_like'||communityData.operation=='admin_comment')">

          <h1 v-if="communityData.admin_id&&(communityData.operation=='admin_like')">{{communityData.from_user.username
            || '超级简历用户'}}
            等{{communityData.remark}}人{{operationType(communityData.operation)}}了你的{{noticeType(communityData.type)}}</h1>

          <h1 v-if="communityData.admin_id&&(communityData.operation=='admin_comment')">
            {{communityData.from_user.username || '超级简历用户'}}
            {{operationType(communityData.operation)}}了你的{{noticeType(communityData.type)}}</h1>
        </div>
        <div class="date_time community-item-date">{{communityData.operation_at | articleTimeFormatFilter}}</div>
      </div>
      <!--      <p class="community-item-date">2小时前</p>-->
      <p class="community-item-desc">
        <span ref="communityContent" :style="ellipsisStyle"
              v-if="communityData.operation !== 'participant_vote_end' && communityData.operation !== 'vote_end'">{{communityData.type === 'news' ? (communityData.title ? communityData.title : communityData.content):(communityData.comment.is_delete ? '该评论已删除' : communityData.comment.content)}}</span>
        <span :style="ellipsisStyle" v-else>{{communityData.vote.name}}</span>
      </p>
      <p class="community-item-topic" v-show="communityData.admin_id && communityData.operation==='delete'">
        删除原因：{{communityData.remark || '无'}}，如需申诉请联系在线客服</p>
      <p class="community-item-topic" v-show="communityData.admin_id && communityData.operation==='update_topic'">
        话题修改为：#{{communityData.topic.name}}</p>
      <!--      <p class="community-item-topic" v-show="communityData.operation!='update_topic' && communityData.operation!='delete'">-->
      <!--        &lt;!&ndash;        <i class="iconfont iconRectangle"></i>&ndash;&gt;-->
      <!--        #{{communityData.topic.name}}-->
      <!--      </p>-->
    </div>
  </div>
</template>

<script>
  import {componentsMixin} from '../../../assets/js/mixin/components'
  import {envMixin} from '../../../assets/js/mixin/global'

  export default {
    name: 'message-item',
    mixins: [componentsMixin, envMixin],
    props: {
      communityData: {
        type: Object,
        default: () => {
          return {}
        }
      },
      dataType: {
        type: String,
        default: 'list'
      }
    },
    data() {
      return {
        commentShow: false,
      }
    },
    mounted() {
      this.listenLinkClick()
    },
    computed: {
      ellipsisStyle() {
        return this.$route.name !== 'article-detail' ? {
          overflow: 'hidden',
          'text-overflow': 'ellipsis',
          display: '-webkit-box', //作为弹性伸缩盒子模型显示。
          '-webkit-box-orient': 'vertical', //设置伸缩盒子的子元素排列方式--从上到下垂直排列
          '-webkit-line-clamp': 4 //显示的行
        } : {}
      },
      linkContent() {
        // const re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[a-zA-Z0-9\.\-~!@#$%^&*+?:_/=<>[\u4e00-\u9fa5]*]*)+)|(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-\.\/\?%&=]*)?)/gi
        const re = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#]))/gi
        if (this.communityData.content) {
          return this.communityData.content.replace(re, a => `<span class="iconfont iconlink"></span><a href="${a}">网页链接</a>`)
        }
      }
    },
    watch: {},
    components: {},
    methods: {
      listenLinkClick() {
        this.$refs['communityContent']&&this.$refs['communityContent'].addEventListener('click', (event) => {
          event.preventDefault()
        })
      },
      // 消息类型返回
      noticeType(type) {
        if (type === 'news') {
          return '帖子'
        } else if (type === 'page') {
          return '攻略文章'
        } else if (type === 'comment') {
          return '评论'
        } else if (type === 'comments') {
          return '评论'
        }
      },
      // 操作返回
      operationType(state) {
        switch (state) {
          case 'like':
            return '点赞';
            break;
          case 'collect':
            return '收藏';
            break;
          case 'comment':
            return '回复';
            break;
          case 'delete':
            return '删除';
            break;
          case 'top':
            return '置顶';
            break;
          case 'admin_like':
            return '点赞';
            break;
          case 'admin_comment':
            return '回复';
            break;
        }
      },
      // 显示大图
      showBigImg(index) {
        this.bigImgState = true;
        this.imgIndex = index
      },
      // 跳转攻略详情
      toBlogDetail() {
        let {page: {token, name}} = this.communityData
        this.$db.ls.set('shareNeed', true)
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/blog-detail/blog-detail?url=${process.env.VUE_APP_HOST}/community/blog/${token}&title=${name}`
          })
        } else {
          this.$router.push(`/community/blog/${token}`)
        }
      },
      // 跳转文章详情
      toArticleDetail(type) {
        let {id, title, content} = this.communityData
        let {name} = this.$route
        if (name === 'article-detail') {
          type === 'share' ? this.shareWxState = true :
            type === 'comment' ? this.$emit('handleComment', 'create', this.communityData) :
              ''
        } else {
          this.$db.ls.set('shareNeed', true)
          if (this.isWxMini) {
            this.$wechat.miniProgram.navigateTo({
              url: `/pages/news-detail/news-detail?url=${process.env.VUE_APP_HOST}/community/article/${id}&title=${title || content}`
            })
          } else {
            this.$router.push(`/community/article/${id}`)
          }
        }
      },
      // 跳转话题聚合页
      toTopicDetail() {
        let {topic: {id, name, image}} = this.communityData
        this.$db.ls.set('shareNeed', true)
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/news-group/news-group?url=${process.env.VUE_APP_HOST}/community/topic/${id}&title=${name}&image=${image}`
          })
        } else {
          this.$router.push(`/community/topic/${id}`)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  //.big_img_container{
  //  width: 100vh;
  //}
  .community-item {
    padding: 24px 24px 18px;
    background-color: $color-light;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    .community-item-header {
      margin-bottom: 8px;

      .user-info {
        .user-avatar {
          margin-right: 8px;
          flex-shrink: 1;

          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
          }
        }

        span {
          color: $color-dark-gray;
          font-size: $font-size-small;
        }
      }

      .post-type {
        color: #D7AC6D;
        font-size: $font-size-small;
      }
    }

    .community-item-page {
      margin: 2px 0 8px 0;
      padding: 16px 24px 16px 16px;
      background-color: #F9F9F9;
      border-radius: 6px;

      .page-info {
        flex-shrink: 1;

        .page-title {
          color: $color-title;
          font-weight: 600;
          margin-bottom: 12px;
        }

        .page-desc {
          font-size: $font-size-small;
          color: #9c9c9c;
        }
      }

      img {
        width: 36px;
        height: 36px;
        border-radius: 4px;
        /*margin-left: 10px;*/
        border: 1px solid #000;
      }
    }

    .community-item-content {
      //margin-bottom: 20px;
      .community-item-title {
        font-size: $font-size-medium;
        color: $color-title;
        line-height: 22px;
        margin-bottom: 4px;
        display: flex;
        justify-content: space-between;

        .messages {
          width: 77%;
          display: flex;
          align-items: center;

          h1 {
            width: calc(100% - 37px);
            margin-left: 10px;
          }

          img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }
        }
      }

      .community-item-date {
        font-size: 12px;
        color: #9c9c9c;
        //margin-bottom: 8px;
      }

      .community-item-topic {
        line-height: 20px;
        font-size: 12px;
        color: #9c9c9c;

        .iconfont {
          font-size: 10px;
        }
      }

      //.community-item-topic:before{
      //  content: '';
      //  width: 0;
      //  height: 0;
      //  border-color: #9c9c9c;
      //border-top: 0px solid transparent;
      //border-right: 0px solid transparent;
      //border-bottom: 0px solid transparent;
      //border-left: 10px solid #9c9c9c;
      //}
      .community-item-desc {
        color: #606060;
        line-height: 20px;
        margin-bottom: 8px;
        word-break: break-all;
        padding: 10px;
        background-color: #f9f9f9;

        /deep/ a {
          color: #3381FF;
        }

        /deep/ .iconlink {
          color: #3381FF;
          font-weight: 600;
        }
      }

      .community-item-images {
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 8px;

        img {
          width: 104px;
          height: 104px;
          border-radius: 4px;
          object-fit: cover;
          margin-bottom: 8px;
        }
      }

      .community-update-time-wrapper {
        margin-top: 16px;

        .community-update-time {
          color: #9C9C9C;
          font-size: $font-size-small;
        }

        span {
          font-size: 12px;
          color: #9c9c9c;
        }

        .iconfont {
          font-size: 16px;
          margin-right: 4px;
          font-weight: 500;
        }
      }

      .topic {
        /*width: 60px;*/
        width: fit-content;
        padding: 4px 8px 4px 4px;
        background-color: rgba($color: #FF6644, $alpha: .05);
        border-radius: 12px;

        .icon {
          width: 18px;
          height: 18px;
          background-color: #FF6644;
          border-radius: 12px;
          margin-right: 6px;
          color: $color-light;
        }

        .community-item-text {
          color: $color-theme;
          font-size: $font-size-small;
        }
      }

      .community-detail-topic {
        padding: 8px 16px;
        background-color: #FEFFFF;
        border: 1px solid #F4F4F4;
        border-radius: 4px;
        margin-top: 16px;
        object-fit: cover;

        img {
          width: 30px;
          height: 30px;
          border-radius: 4px;
          margin-right: 10px;
        }

        .topic-info {
          .title {
            font-size: $font-size-small;
            color: $color-dark-gray;
            margin-bottom: 4px;
          }

          .community-num {
            color: #9C9C9C;
            font-size: $font-size-small;
          }
        }

        .topic-detail {
          width: 60px;
          height: 26px;
          border-radius: 14px;
          background-color: #f4f4f4;
          color: #606060;
          font-size: $font-size-small;
        }
      }
    }

    .community-item-footer {
      .operation-item {
        margin-right: 33px;
        font-size: $font-size-small;

        &:last-child {
          margin-right: 0;
        }

        .iconfont {
          font-size: 16px;
          margin-right: 6px;
        }

        img {
          width: 16px;
          margin-right: 6px;
        }
      }

      .enjoy, .like, .comment, .approve {
        color: #9c9c9c;
      }

      .like-total, .approve-total {
        min-width: 12px
      }
    }
  }
</style>
